export const PATH_TO_IMAGE = 'static/images/';
export const TELEGRAM_BOT_URL = process.env.REACT_APP_TELEGRAM_BOT_URL;
export enum BUILD_TYPE {
  STAGE = 'stage',
  LOCAL = 'local',
  DEV = 'dev',
  PROD = 'prod',
}
export enum LANGUAGE {
  RU = 'RU',
  EN = 'EN',
  KY = 'KY',
}
